module.exports = __webpack_public_path__ + "static/media/27.6a113557.svg";